import { HospitalityMenuCategory, HospitalityMenuCategoryItem } from "@/lib/types";
import { getHospitalityMenuCategoryItem } from "@/sideEffects/api";
import { useQuery } from "@tanstack/react-query";
import { BaseDataTable } from "@/components/dataTable/BaseDataTable";
import { useTranslation } from "react-i18next";
import { ColumnDef } from "@tanstack/react-table";
import { DeleteHospitalityMenuCategoryItemDialog } from "./DeleteHospitalityMenuCategoryItemDialog";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import { UpdateHospitalityMenuCategoryItemDialog } from "./updateHospitalityMenuCategoryItem/UpdateHospitalityMenuCategoryItemDialog";

interface Props {
  category: HospitalityMenuCategory;
}

export const HospitalityMenuCategoryItems: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();

  const { data: hospitalityMenuCategoryItems, isLoading: isHospitalityMenuCategoryItemsLoading } = useQuery({
    queryKey: ["getHospitalityMenuCategoryItem", category.hMenu_Id],
    queryFn: () => getHospitalityMenuCategoryItem(category.hMenu_Id),
  });

  const filteredItems =
    hospitalityMenuCategoryItems?.data.result?.filter((item) => item.hMenuCategory_Id === category.id) || [];

  const columns: ColumnDef<HospitalityMenuCategoryItem>[] = [
    {
      accessorKey: "name",
      header: t("common.name"),
    },
    {
      accessorKey: "price",
      header: t("common.price"),
    },
    {
      accessorKey: "id",
      header: () => "",
      cell: ({ row }) => {
        return (
          <div className="flex items-center justify-end gap-2">
            <UpdateHospitalityMenuCategoryItemDialog category={category} categoryItem={row.original} />
            <DeleteHospitalityMenuCategoryItemDialog category={category} categoryItem={row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <LoadingOverlay isLoading={isHospitalityMenuCategoryItemsLoading}>
      <div className="border border-t-0 p-2 ml-4">
        <BaseDataTable
          columns={columns}
          data={filteredItems}
          rowCount={hospitalityMenuCategoryItems?.data.totalRecord || 0}
          getRowId={(row) => row.id.toString()}
        />
      </div>
    </LoadingOverlay>
  );
};
